/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { CountOperations200Response } from '../models';
// @ts-ignore
import type { DeleteOperation200Response } from '../models';
// @ts-ignore
import type { GetMyOperations200Response } from '../models';
// @ts-ignore
import type { GetOperationDetails200Response } from '../models';
// @ts-ignore
import type { GetOperationFiles200Response } from '../models';
// @ts-ignore
import type { GetOperationsByUserId200Response } from '../models';
// @ts-ignore
import type { LeaveOperation200Response } from '../models';
// @ts-ignore
import type { OperationChangeDefaultDrawLayerDTO } from '../models';
// @ts-ignore
import type { OperationCreateDTO } from '../models';
// @ts-ignore
import type { OperationPatchDTO } from '../models';
// @ts-ignore
import type { OperationUpdateLocalRolesDTO } from '../models';
// @ts-ignore
import type { SearchGroupsAdmin200Response } from '../models';
// @ts-ignore
import type { SortOrder } from '../models';
// @ts-ignore
import type { UpdateLocalRolesInOperation200Response } from '../models';
// @ts-ignore
import type { UpdateOperation200Response } from '../models';
/**
 * NexusOperationApi - axios parameter creator
 */
export const NexusOperationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Update an operation from the admin panel
         * @summary Update an operation
         * @param {string} operationId 
         * @param {OperationCreateDTO} operationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOperation: async (operationId: string, operationCreateDTO: OperationCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('adminUpdateOperation', 'operationId', operationId)
            // verify required parameter 'operationCreateDTO' is not null or undefined
            assertParamExists('adminUpdateOperation', 'operationCreateDTO', operationCreateDTO)
            const localVarPath = `/api/nora/nexus/operation/admin/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the count of operations you have access to
         * @summary Get the operation count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOperations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/operation/admin/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create an operation
         * @summary Create an operation
         * @param {OperationCreateDTO} operationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperation: async (operationCreateDTO: OperationCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationCreateDTO' is not null or undefined
            assertParamExists('createOperation', 'operationCreateDTO', operationCreateDTO)
            const localVarPath = `/api/nora/nexus/operation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a specific operation
         * @summary Delete an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperation: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('deleteOperation', 'operationId', operationId)
            const localVarPath = `/api/nora/nexus/operation/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all the operations you have access to
         * @summary List your operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOperations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/operation/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return detailed information about an operation you have access to
         * @summary Get details for an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationDetails: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getOperationDetails', 'operationId', operationId)
            const localVarPath = `/api/nora/nexus/operation/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return detailed information about an operation in the admin panel
         * @summary Get details for an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationDetailsAdmin: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getOperationDetailsAdmin', 'operationId', operationId)
            const localVarPath = `/api/nora/nexus/operation/admin/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return files for a specific operation you have access to
         * @summary Get files for an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationFiles: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('getOperationFiles', 'operationId', operationId)
            const localVarPath = `/api/nora/nexus/operation/{operationId}/files`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List all the operations a specific user has access to
         * @summary List all operations for a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationsByUserId: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getOperationsByUserId', 'userId', userId)
            const localVarPath = `/api/nora/nexus/operation/admin/user/{userId}`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Leave an operation you are part of
         * @summary Leave an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveOperation: async (operationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('leaveOperation', 'operationId', operationId)
            const localVarPath = `/api/nora/nexus/operation/{operationId}/leave`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This patches specific fields of the operation. At the moment, we only support patching the name, but in the future we can add more fields to patch here if needed.
         * @summary Patches specific fields of the operation.
         * @param {string} operationId 
         * @param {OperationPatchDTO} operationPatchDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOperation: async (operationId: string, operationPatchDTO: OperationPatchDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('patchOperation', 'operationId', operationId)
            // verify required parameter 'operationPatchDTO' is not null or undefined
            assertParamExists('patchOperation', 'operationPatchDTO', operationPatchDTO)
            const localVarPath = `/api/nora/nexus/operation/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationPatchDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove a user from a operation
         * @summary Remove a user from a operation
         * @param {string} operationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromOperation: async (operationId: string, userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('removeUserFromOperation', 'operationId', operationId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('removeUserFromOperation', 'userId', userId)
            const localVarPath = `/api/nora/nexus/operation/{operationId}/user/{userId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)))
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Users can search for operations they have access to
         * @summary User can search for their operations
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOperations: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/operation/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admins can search for all operations
         * @summary Admin search for operations
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOperationsAdmin: async (query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/operation/admin/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint enables updating the default draw layer of the operation. It will replace the existing layer with the provided one.
         * @summary Endpoint to update the default draw layer of the operation.
         * @param {string} operationId 
         * @param {OperationChangeDefaultDrawLayerDTO} operationChangeDefaultDrawLayerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultLayer: async (operationId: string, operationChangeDefaultDrawLayerDTO: OperationChangeDefaultDrawLayerDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('setDefaultLayer', 'operationId', operationId)
            // verify required parameter 'operationChangeDefaultDrawLayerDTO' is not null or undefined
            assertParamExists('setDefaultLayer', 'operationChangeDefaultDrawLayerDTO', operationChangeDefaultDrawLayerDTO)
            const localVarPath = `/api/nora/nexus/operation/{operationId}/default-draw-layer`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationChangeDefaultDrawLayerDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates the local roles for an operation. This supports partial success, so if some local role updates fail, the others can still succeed and the response will indicate which ones succeeded and which ones failed.
         * @summary Update the local roles in an operation
         * @param {string} operationId 
         * @param {OperationUpdateLocalRolesDTO} operationUpdateLocalRolesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocalRolesInOperation: async (operationId: string, operationUpdateLocalRolesDTO: OperationUpdateLocalRolesDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('updateLocalRolesInOperation', 'operationId', operationId)
            // verify required parameter 'operationUpdateLocalRolesDTO' is not null or undefined
            assertParamExists('updateLocalRolesInOperation', 'operationUpdateLocalRolesDTO', operationUpdateLocalRolesDTO)
            const localVarPath = `/api/nora/nexus/operation/{operationId}/local-roles`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationUpdateLocalRolesDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an operation
         * @summary Update an operation
         * @param {string} operationId 
         * @param {OperationCreateDTO} operationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperation: async (operationId: string, operationCreateDTO: OperationCreateDTO, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'operationId' is not null or undefined
            assertParamExists('updateOperation', 'operationId', operationId)
            // verify required parameter 'operationCreateDTO' is not null or undefined
            assertParamExists('updateOperation', 'operationCreateDTO', operationCreateDTO)
            const localVarPath = `/api/nora/nexus/operation/{operationId}`
                .replace('{operationId}', encodeURIComponent(String(operationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(operationCreateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NexusOperationApi - functional programming interface
 */
export const NexusOperationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NexusOperationApiAxiosParamCreator(configuration)
    return {
        /**
         * Update an operation from the admin panel
         * @summary Update an operation
         * @param {string} operationId 
         * @param {OperationCreateDTO} operationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminUpdateOperation(operationId: string, operationCreateDTO: OperationCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminUpdateOperation(operationId, operationCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.adminUpdateOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the count of operations you have access to
         * @summary Get the operation count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async countOperations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CountOperations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.countOperations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.countOperations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create an operation
         * @summary Create an operation
         * @param {OperationCreateDTO} operationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOperation(operationCreateDTO: OperationCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOperation(operationCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.createOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a specific operation
         * @summary Delete an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOperation(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOperation(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.deleteOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all the operations you have access to
         * @summary List your operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyOperations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMyOperations200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyOperations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.getMyOperations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return detailed information about an operation you have access to
         * @summary Get details for an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperationDetails(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperationDetails(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.getOperationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return detailed information about an operation in the admin panel
         * @summary Get details for an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperationDetailsAdmin(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationDetails200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperationDetailsAdmin(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.getOperationDetailsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Return files for a specific operation you have access to
         * @summary Get files for an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperationFiles(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationFiles200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperationFiles(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.getOperationFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List all the operations a specific user has access to
         * @summary List all operations for a user
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOperationsByUserId(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOperationsByUserId200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOperationsByUserId(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.getOperationsByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Leave an operation you are part of
         * @summary Leave an operation
         * @param {string} operationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async leaveOperation(operationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LeaveOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.leaveOperation(operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.leaveOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This patches specific fields of the operation. At the moment, we only support patching the name, but in the future we can add more fields to patch here if needed.
         * @summary Patches specific fields of the operation.
         * @param {string} operationId 
         * @param {OperationPatchDTO} operationPatchDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchOperation(operationId: string, operationPatchDTO: OperationPatchDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchOperation(operationId, operationPatchDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.patchOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Remove a user from a operation
         * @summary Remove a user from a operation
         * @param {string} operationId 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeUserFromOperation(operationId: string, userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeUserFromOperation(operationId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.removeUserFromOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Users can search for operations they have access to
         * @summary User can search for their operations
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOperations(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOperations(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.searchOperations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admins can search for all operations
         * @summary Admin search for operations
         * @param {string} [query] 
         * @param {string} [filter] 
         * @param {number} [skip] 
         * @param {number} [limit] 
         * @param {SortOrder} [sortOrder] 
         * @param {string} [cursor] 
         * @param {string} [sortBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchOperationsAdmin(query?: string, filter?: string, skip?: number, limit?: number, sortOrder?: SortOrder, cursor?: string, sortBy?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchGroupsAdmin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchOperationsAdmin(query, filter, skip, limit, sortOrder, cursor, sortBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.searchOperationsAdmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * This endpoint enables updating the default draw layer of the operation. It will replace the existing layer with the provided one.
         * @summary Endpoint to update the default draw layer of the operation.
         * @param {string} operationId 
         * @param {OperationChangeDefaultDrawLayerDTO} operationChangeDefaultDrawLayerDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDefaultLayer(operationId: string, operationChangeDefaultDrawLayerDTO: OperationChangeDefaultDrawLayerDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDefaultLayer(operationId, operationChangeDefaultDrawLayerDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.setDefaultLayer']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates the local roles for an operation. This supports partial success, so if some local role updates fail, the others can still succeed and the response will indicate which ones succeeded and which ones failed.
         * @summary Update the local roles in an operation
         * @param {string} operationId 
         * @param {OperationUpdateLocalRolesDTO} operationUpdateLocalRolesDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLocalRolesInOperation(operationId: string, operationUpdateLocalRolesDTO: OperationUpdateLocalRolesDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateLocalRolesInOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLocalRolesInOperation(operationId, operationUpdateLocalRolesDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.updateLocalRolesInOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an operation
         * @summary Update an operation
         * @param {string} operationId 
         * @param {OperationCreateDTO} operationCreateDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOperation(operationId: string, operationCreateDTO: OperationCreateDTO, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateOperation200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOperation(operationId, operationCreateDTO, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NexusOperationApi.updateOperation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NexusOperationApi - factory interface
 */
export const NexusOperationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NexusOperationApiFp(configuration)
    return {
        /**
         * Update an operation from the admin panel
         * @summary Update an operation
         * @param {NexusOperationApiAdminUpdateOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateOperation(requestParameters: NexusOperationApiAdminUpdateOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateOperation200Response> {
            return localVarFp.adminUpdateOperation(requestParameters.operationId, requestParameters.operationCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the count of operations you have access to
         * @summary Get the operation count
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        countOperations(options?: RawAxiosRequestConfig): AxiosPromise<CountOperations200Response> {
            return localVarFp.countOperations(options).then((request) => request(axios, basePath));
        },
        /**
         * Create an operation
         * @summary Create an operation
         * @param {NexusOperationApiCreateOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOperation(requestParameters: NexusOperationApiCreateOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateOperation200Response> {
            return localVarFp.createOperation(requestParameters.operationCreateDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a specific operation
         * @summary Delete an operation
         * @param {NexusOperationApiDeleteOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOperation(requestParameters: NexusOperationApiDeleteOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteOperation200Response> {
            return localVarFp.deleteOperation(requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all the operations you have access to
         * @summary List your operations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyOperations(options?: RawAxiosRequestConfig): AxiosPromise<GetMyOperations200Response> {
            return localVarFp.getMyOperations(options).then((request) => request(axios, basePath));
        },
        /**
         * Return detailed information about an operation you have access to
         * @summary Get details for an operation
         * @param {NexusOperationApiGetOperationDetailsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationDetails(requestParameters: NexusOperationApiGetOperationDetailsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationDetails200Response> {
            return localVarFp.getOperationDetails(requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return detailed information about an operation in the admin panel
         * @summary Get details for an operation
         * @param {NexusOperationApiGetOperationDetailsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationDetailsAdmin(requestParameters: NexusOperationApiGetOperationDetailsAdminRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationDetails200Response> {
            return localVarFp.getOperationDetailsAdmin(requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * Return files for a specific operation you have access to
         * @summary Get files for an operation
         * @param {NexusOperationApiGetOperationFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationFiles(requestParameters: NexusOperationApiGetOperationFilesRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationFiles200Response> {
            return localVarFp.getOperationFiles(requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * List all the operations a specific user has access to
         * @summary List all operations for a user
         * @param {NexusOperationApiGetOperationsByUserIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOperationsByUserId(requestParameters: NexusOperationApiGetOperationsByUserIdRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetOperationsByUserId200Response> {
            return localVarFp.getOperationsByUserId(requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Leave an operation you are part of
         * @summary Leave an operation
         * @param {NexusOperationApiLeaveOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        leaveOperation(requestParameters: NexusOperationApiLeaveOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LeaveOperation200Response> {
            return localVarFp.leaveOperation(requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * This patches specific fields of the operation. At the moment, we only support patching the name, but in the future we can add more fields to patch here if needed.
         * @summary Patches specific fields of the operation.
         * @param {NexusOperationApiPatchOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchOperation(requestParameters: NexusOperationApiPatchOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.patchOperation(requestParameters.operationId, requestParameters.operationPatchDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove a user from a operation
         * @summary Remove a user from a operation
         * @param {NexusOperationApiRemoveUserFromOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeUserFromOperation(requestParameters: NexusOperationApiRemoveUserFromOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteOperation200Response> {
            return localVarFp.removeUserFromOperation(requestParameters.operationId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Users can search for operations they have access to
         * @summary User can search for their operations
         * @param {NexusOperationApiSearchOperationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOperations(requestParameters: NexusOperationApiSearchOperationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchOperations(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * Admins can search for all operations
         * @summary Admin search for operations
         * @param {NexusOperationApiSearchOperationsAdminRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOperationsAdmin(requestParameters: NexusOperationApiSearchOperationsAdminRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SearchGroupsAdmin200Response> {
            return localVarFp.searchOperationsAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint enables updating the default draw layer of the operation. It will replace the existing layer with the provided one.
         * @summary Endpoint to update the default draw layer of the operation.
         * @param {NexusOperationApiSetDefaultLayerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDefaultLayer(requestParameters: NexusOperationApiSetDefaultLayerRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.setDefaultLayer(requestParameters.operationId, requestParameters.operationChangeDefaultDrawLayerDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates the local roles for an operation. This supports partial success, so if some local role updates fail, the others can still succeed and the response will indicate which ones succeeded and which ones failed.
         * @summary Update the local roles in an operation
         * @param {NexusOperationApiUpdateLocalRolesInOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLocalRolesInOperation(requestParameters: NexusOperationApiUpdateLocalRolesInOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateLocalRolesInOperation200Response> {
            return localVarFp.updateLocalRolesInOperation(requestParameters.operationId, requestParameters.operationUpdateLocalRolesDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an operation
         * @summary Update an operation
         * @param {NexusOperationApiUpdateOperationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOperation(requestParameters: NexusOperationApiUpdateOperationRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateOperation200Response> {
            return localVarFp.updateOperation(requestParameters.operationId, requestParameters.operationCreateDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminUpdateOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiAdminUpdateOperationRequest {
    readonly operationId: string

    readonly operationCreateDTO: OperationCreateDTO
}

/**
 * Request parameters for createOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiCreateOperationRequest {
    readonly operationCreateDTO: OperationCreateDTO
}

/**
 * Request parameters for deleteOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiDeleteOperationRequest {
    readonly operationId: string
}

/**
 * Request parameters for getOperationDetails operation in NexusOperationApi.
 */
export interface NexusOperationApiGetOperationDetailsRequest {
    readonly operationId: string
}

/**
 * Request parameters for getOperationDetailsAdmin operation in NexusOperationApi.
 */
export interface NexusOperationApiGetOperationDetailsAdminRequest {
    readonly operationId: string
}

/**
 * Request parameters for getOperationFiles operation in NexusOperationApi.
 */
export interface NexusOperationApiGetOperationFilesRequest {
    readonly operationId: string
}

/**
 * Request parameters for getOperationsByUserId operation in NexusOperationApi.
 */
export interface NexusOperationApiGetOperationsByUserIdRequest {
    readonly userId: string
}

/**
 * Request parameters for leaveOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiLeaveOperationRequest {
    readonly operationId: string
}

/**
 * Request parameters for patchOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiPatchOperationRequest {
    readonly operationId: string

    readonly operationPatchDTO: OperationPatchDTO
}

/**
 * Request parameters for removeUserFromOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiRemoveUserFromOperationRequest {
    readonly operationId: string

    readonly userId: string
}

/**
 * Request parameters for searchOperations operation in NexusOperationApi.
 */
export interface NexusOperationApiSearchOperationsRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for searchOperationsAdmin operation in NexusOperationApi.
 */
export interface NexusOperationApiSearchOperationsAdminRequest {
    readonly query?: string

    readonly filter?: string

    readonly skip?: number

    readonly limit?: number

    readonly sortOrder?: SortOrder

    readonly cursor?: string

    readonly sortBy?: string
}

/**
 * Request parameters for setDefaultLayer operation in NexusOperationApi.
 */
export interface NexusOperationApiSetDefaultLayerRequest {
    readonly operationId: string

    readonly operationChangeDefaultDrawLayerDTO: OperationChangeDefaultDrawLayerDTO
}

/**
 * Request parameters for updateLocalRolesInOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiUpdateLocalRolesInOperationRequest {
    readonly operationId: string

    readonly operationUpdateLocalRolesDTO: OperationUpdateLocalRolesDTO
}

/**
 * Request parameters for updateOperation operation in NexusOperationApi.
 */
export interface NexusOperationApiUpdateOperationRequest {
    readonly operationId: string

    readonly operationCreateDTO: OperationCreateDTO
}

/**
 * NexusOperationApi - object-oriented interface
 */
export class NexusOperationApi extends BaseAPI {
    /**
     * Update an operation from the admin panel
     * @summary Update an operation
     * @param {NexusOperationApiAdminUpdateOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminUpdateOperation(requestParameters: NexusOperationApiAdminUpdateOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).adminUpdateOperation(requestParameters.operationId, requestParameters.operationCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the count of operations you have access to
     * @summary Get the operation count
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public countOperations(options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).countOperations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create an operation
     * @summary Create an operation
     * @param {NexusOperationApiCreateOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createOperation(requestParameters: NexusOperationApiCreateOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).createOperation(requestParameters.operationCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a specific operation
     * @summary Delete an operation
     * @param {NexusOperationApiDeleteOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteOperation(requestParameters: NexusOperationApiDeleteOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).deleteOperation(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all the operations you have access to
     * @summary List your operations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMyOperations(options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).getMyOperations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return detailed information about an operation you have access to
     * @summary Get details for an operation
     * @param {NexusOperationApiGetOperationDetailsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOperationDetails(requestParameters: NexusOperationApiGetOperationDetailsRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).getOperationDetails(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return detailed information about an operation in the admin panel
     * @summary Get details for an operation
     * @param {NexusOperationApiGetOperationDetailsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOperationDetailsAdmin(requestParameters: NexusOperationApiGetOperationDetailsAdminRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).getOperationDetailsAdmin(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Return files for a specific operation you have access to
     * @summary Get files for an operation
     * @param {NexusOperationApiGetOperationFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOperationFiles(requestParameters: NexusOperationApiGetOperationFilesRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).getOperationFiles(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List all the operations a specific user has access to
     * @summary List all operations for a user
     * @param {NexusOperationApiGetOperationsByUserIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getOperationsByUserId(requestParameters: NexusOperationApiGetOperationsByUserIdRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).getOperationsByUserId(requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Leave an operation you are part of
     * @summary Leave an operation
     * @param {NexusOperationApiLeaveOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public leaveOperation(requestParameters: NexusOperationApiLeaveOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).leaveOperation(requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This patches specific fields of the operation. At the moment, we only support patching the name, but in the future we can add more fields to patch here if needed.
     * @summary Patches specific fields of the operation.
     * @param {NexusOperationApiPatchOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public patchOperation(requestParameters: NexusOperationApiPatchOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).patchOperation(requestParameters.operationId, requestParameters.operationPatchDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Remove a user from a operation
     * @summary Remove a user from a operation
     * @param {NexusOperationApiRemoveUserFromOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public removeUserFromOperation(requestParameters: NexusOperationApiRemoveUserFromOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).removeUserFromOperation(requestParameters.operationId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Users can search for operations they have access to
     * @summary User can search for their operations
     * @param {NexusOperationApiSearchOperationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchOperations(requestParameters: NexusOperationApiSearchOperationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).searchOperations(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admins can search for all operations
     * @summary Admin search for operations
     * @param {NexusOperationApiSearchOperationsAdminRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchOperationsAdmin(requestParameters: NexusOperationApiSearchOperationsAdminRequest = {}, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).searchOperationsAdmin(requestParameters.query, requestParameters.filter, requestParameters.skip, requestParameters.limit, requestParameters.sortOrder, requestParameters.cursor, requestParameters.sortBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint enables updating the default draw layer of the operation. It will replace the existing layer with the provided one.
     * @summary Endpoint to update the default draw layer of the operation.
     * @param {NexusOperationApiSetDefaultLayerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public setDefaultLayer(requestParameters: NexusOperationApiSetDefaultLayerRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).setDefaultLayer(requestParameters.operationId, requestParameters.operationChangeDefaultDrawLayerDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates the local roles for an operation. This supports partial success, so if some local role updates fail, the others can still succeed and the response will indicate which ones succeeded and which ones failed.
     * @summary Update the local roles in an operation
     * @param {NexusOperationApiUpdateLocalRolesInOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateLocalRolesInOperation(requestParameters: NexusOperationApiUpdateLocalRolesInOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).updateLocalRolesInOperation(requestParameters.operationId, requestParameters.operationUpdateLocalRolesDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an operation
     * @summary Update an operation
     * @param {NexusOperationApiUpdateOperationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateOperation(requestParameters: NexusOperationApiUpdateOperationRequest, options?: RawAxiosRequestConfig) {
        return NexusOperationApiFp(this.configuration).updateOperation(requestParameters.operationId, requestParameters.operationCreateDTO, options).then((request) => request(this.axios, this.basePath));
    }
}

